<script setup lang="ts">
import { type HTMLAttributes, computed } from 'vue'
import { type ButtonVariants, buttonVariants } from '.'
import { cn } from '@/lib/utils'

const props = withDefaults(
    defineProps<{
        variant?: ButtonVariants['variant']
        size?: ButtonVariants['size']
        class?: HTMLAttributes['class']
        as?: string
    }>(),
    {
        as: 'button',
    },
)

const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props
    return delegated
})
</script>

<template>
    <component
        :is="as"
        :class="cn(buttonVariants({ variant, size }), props.class)"
        v-bind="delegatedProps"
    >
        <slot />
    </component>
</template>
